<template>
    <date-pick
            :id="this.id"
            v-model="model"
            :displayFormat="'YYYY-MM-DD'"
    ></date-pick>
</template>

<style>
    .vdpTable {
        font-size: 10px;
    }

    .vdpClearInput{
        display: none;
    }

</style>

<script>
    import DatePick from 'vue-date-pick';

    export default {
        components: {DatePick},
        props: {
            current: {
                type: String,
                required: false,
                default: '',
            },
            id: {
                type: String,
                required: false,
                default: 'dob',
            },
            name: {
                type: String,
                required: false,
                default: 'dob',
            },
            placeHolder: {
                type: String,
                required: false,
                default: '',
            }
        },
        data: () => ({
            model: '',
            currentDate:''
        }),
        mounted() {
            this.currentDate = this.current;
            // document.getElementsByClassName('position-relative')[0].classList.add('form-control');
            // document.getElementsByClassName('position-relative')[0].style.padding = '0';
            document.getElementById(this.id).classList.add('form-control');
            document.getElementById(this.id).style.padding = '0';
            document.getElementById(this.id).getElementsByTagName('input')[0].classList.add('form-control');
            document.getElementById(this.id).getElementsByTagName('input')[0].setAttribute('name', this.name);
            document.getElementById(this.id).getElementsByTagName('input')[0].setAttribute('placeholder', this.placeHolder);
            document.getElementById(this.id).getElementsByTagName('input')[0].setAttribute("autocomplete", "off");
            if (this.currentDate) {
                document.getElementById(this.id).getElementsByTagName('input')[0].setAttribute("value", this.currentDate);
            }
        },
    };
</script>
